import { render, staticRenderFns } from "./RoleDrawerKnowledgeViewer.vue?vue&type=template&id=3b56a678&scoped=true&"
import script from "./RoleDrawerKnowledgeViewer.vue?vue&type=script&lang=js&"
export * from "./RoleDrawerKnowledgeViewer.vue?vue&type=script&lang=js&"
import style0 from "./RoleDrawerKnowledgeViewer.vue?vue&type=style&index=0&id=3b56a678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b56a678",
  null
  
)

export default component.exports